import React from "react";
import {GoalsService, LoginService} from "./api/server_calls";

class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                fontSize:"16px",
                height:"26px",
                maxWidth:"100%"
            },
            ident: "country"
        }
    }

    componentDidMount = () => {
        // GoalsService.pickCountry(parseInt(document.querySelector("select").value), (result) => this.handleResponse(result));
        if (navigator.userAgent.toLowerCase().indexOf("edge") > -1) {
            setTimeout(function() {document.querySelector("select").value = 4;}, 250);
        }
    }

    handleResponse = (res) => {
        this.props.func(res);
    }

    render() {
        return (
            <div id={this.state.ident}>

                <h5 className="directions" style={{color:"#333"}}>1. Select a country</h5>
                <select style={this.state.style} onChange={() => GoalsService.pickCountry(parseInt(document.querySelector("select").value), (result) => this.handleResponse(result))}>
                    <option value={4}>Afghanistan</option>
                    <option className="dead_air" value={8}>Albania</option>
                    <option className="dead_air" value={12}>Algeria</option>
                    <option className="dead_air" value={24}>Angola</option>
                    <option className="dead_air" value={28}>Antigua and Barbuda</option>
                    <option className="dead_air" value={32}>Argentina</option>
                    <option className="dead_air" value={51}>Armenia</option>
                    <option className="dead_air" value={533}>Aruba</option>
                    <option className="dead_air" value={36}>Australia</option>
                    <option className="dead_air" value={40}>Austria</option>
                    <option className="dead_air" value={31}>Azerbaijan</option>
                    <option className="dead_air" value={44}>Bahamas</option>
                    <option className="dead_air" value={48}>Bahrain</option>
                    <option value={50}>Bangladesh</option>
                    <option className="dead_air" value={52}>Barbados</option>
                    <option className="dead_air" value={112}>Belarus</option>
                    <option className="dead_air" value={56}>Belgium</option>
                    <option className="dead_air" value={84}>Belize</option>
                    <option value={204}>Benin</option>
                    <option value={64}>Bhutan</option>
                    <option value={68}>Bolivia (Plurinational State of)</option>
                    <option className="dead_air" value={70}>Bosnia and Herzegovina</option>
                    <option className="dead_air" value={72}>Botswana</option>
                    <option className="dead_air" value={76}>Brazil</option>
                    <option className="dead_air" value={96}>Brunei Darussalam</option>
                    <option className="dead_air" value={100}>Bulgaria</option>
                    <option value={854}>Burkina Faso</option>
                    <option value={108}>Burundi</option>
                    <option className="dead_air" value={132}>Cabo Verde</option>
                    <option value={116}>Cambodia</option>
                    <option value={120}>Cameroon</option>
                    <option className="dead_air" value={124}>Canada</option>
                    <option value={140}>Central African Republic</option>
                    <option value={148}>Chad</option>
                    <option className="dead_air" value={830}>Channel Islands</option>
                    <option className="dead_air" value={152}>Chile</option>
                    <option className="dead_air" value={156}>China</option>
                    <option className="dead_air" value={344}>China, Hong Kong SAR</option>
                    <option className="dead_air" value={446}>China, Macao SAR</option>
                    <option className="dead_air" value={158}>China, Taiwan Province of China</option>
                    <option className="dead_air" value={170}>Colombia</option>
                    <option value={174}>Comoros</option>
                    <option value={178}>Congo</option>
                    <option className="dead_air" value={188}>Costa Rica</option>
                    <option value={384}>Cote d'Ivoire</option>
                    <option className="dead_air" value={191}>Croatia</option>
                    <option className="dead_air" value={192}>Cuba</option>
                    <option className="dead_air" value={531}>Curacao</option>
                    <option className="dead_air" value={196}>Cyprus</option>
                    <option className="dead_air" value={203}>Czechia</option>
                    <option value={408}>Democratic People's Republic of Korea</option>
                    <option value={180}>Democratic Republic of the Congo</option>
                    <option className="dead_air" value={208}>Denmark</option>
                    <option value={262}>Djibouti</option>
                    <option className="dead_air" value={214}>Dominican Republic</option>
                    <option className="dead_air" value={218}>Ecuador</option>
                    <option value={818}>Egypt</option>
                    <option className="dead_air" value={222}>El Salvador</option>
                    <option className="dead_air" value={226}>Equatorial Guinea</option>
                    <option value={232}>Eritrea</option>
                    <option className="dead_air" value={233}>Estonia</option>
                    <option value={231}>Ethiopia</option>
                    <option className="dead_air" value={242}>Fiji</option>
                    <option className="dead_air" value={246}>Finland</option>
                    <option className="dead_air" value={250}>France</option>
                    <option className="dead_air" value={254}>French Guiana</option>
                    <option className="dead_air" value={258}>French Polynesia</option>
                    <option className="dead_air" value={266}>Gabon</option>
                    <option value={270}>Gambia</option>
                    <option className="dead_air" value={268}>Georgia</option>
                    <option className="dead_air" value={276}>Germany</option>
                    <option value={288}>Ghana</option>
                    <option className="dead_air" value={300}>Greece</option>
                    <option className="dead_air" value={308}>Grenada</option>
                    <option className="dead_air" value={312}>Guadeloupe</option>
                    <option className="dead_air" value={316}>Guam</option>
                    <option className="dead_air" value={320}>Guatemala</option>
                    <option value={324}>Guinea</option>
                    <option value={624}>Guinea-Bissau</option>
                    <option className="dead_air" value={328}>Guyana</option>
                    <option value={332}>Haiti</option>
                    <option value={340}>Honduras</option>
                    <option className="dead_air" value={348}>Hungary</option>
                    <option className="dead_air" value={352}>Iceland</option>
                    <option value={356}>India</option>
                    <option value={360}>Indonesia</option>
                    <option className="dead_air" value={364}>Iran (Islamic Republic of)</option>
                    <option value={368}>Iraq</option>
                    <option className="dead_air" value={372}>Ireland</option>
                    <option className="dead_air" value={376}>Israel</option>
                    <option className="dead_air" value={380}>Italy</option>
                    <option className="dead_air" value={388}>Jamaica</option>
                    <option className="dead_air" value={392}>Japan</option>
                    <option className="dead_air" value={400}>Jordan</option>
                    <option className="dead_air" value={398}>Kazakhstan</option>
                    <option value={404}>Kenya</option>
                    <option className="dead_air" value={296}>Kiribati</option>
                    <option className="dead_air" value={414}>Kuwait</option>
                    <option value={417}>Kyrgyzstan</option>
                    <option value={418}>Lao People's Democratic Republic</option>
                    <option className="dead_air" value={428}>Latvia</option>
                    <option className="dead_air" value={422}>Lebanon</option>
                    <option value={426}>Lesotho</option>
                    <option value={430}>Liberia</option>
                    <option className="dead_air" value={434}>Libya</option>
                    <option className="dead_air" value={440}>Lithuania</option>
                    <option className="dead_air" value={442}>Luxembourg</option>
                    <option value={450}>Madagascar</option>
                    <option value={454}>Malawi</option>
                    <option className="dead_air" value={458}>Malaysia</option>
                    <option className="dead_air" value={462}>Maldives</option>
                    <option value={466}>Mali</option>
                    <option className="dead_air" value={470}>Malta</option>
                    <option className="dead_air" value={474}>Martinique</option>
                    <option value={478}>Mauritania</option>
                    <option className="dead_air" value={480}>Mauritius</option>
                    <option className="dead_air" value={175}>Mayotte</option>
                    <option className="dead_air" value={484}>Mexico</option>
                    <option className="dead_air" value={583}>Micronesia</option>
                    <option value={496}>Mongolia</option>
                    <option className="dead_air" value={499}>Montenegro</option>
                    <option className="dead_air" value={504}>Morocco</option>
                    <option value={508}>Mozambique</option>
                    <option value={104}>Myanmar</option>
                    <option className="dead_air" value={516}>Namibia</option>
                    <option value={524}>Nepal</option>
                    <option className="dead_air" value={528}>Netherlands</option>
                    <option className="dead_air" value={540}>New Caledonia</option>
                    <option className="dead_air" value={554}>New Zealand</option>
                    <option value={558}>Nicaragua</option>
                    <option value={562}>Niger</option>
                    <option value={566}>Nigeria</option>
                    <option className="dead_air" value={578}>Norway</option>
                    <option className="dead_air" value={512}>Oman</option>
                    <option value={586}>Pakistan</option>
                    <option className="dead_air" value={591}>Panama</option>
                    <option value={598}>Papua New Guinea</option>
                    <option className="dead_air" value={600}>Paraguay</option>
                    <option className="dead_air" value={604}>Peru</option>
                    <option value={608}>Philippines</option>
                    <option className="dead_air" value={616}>Poland</option>
                    <option className="dead_air" value={620}>Portugal</option>
                    <option className="dead_air" value={630}>Puerto Rico</option>
                    <option className="dead_air" value={634}>Qatar</option>
                    <option className="dead_air" value={410}>Republic of Korea</option>
                    <option className="dead_air" value={498}>Republic of Moldova</option>
                    <option className="dead_air" value={638}>Reunion</option>
                    <option className="dead_air" value={642}>Romania</option>
                    <option className="dead_air" value={643}>Russian Federation</option>
                    <option value={646}>Rwanda</option>
                    <option className="dead_air" value={662}>Saint Lucia</option>
                    <option className="dead_air" value={670}>Saint Vincent and the Grenadines</option>
                    <option className="dead_air" value={882}>Samoa</option>
                    <option value={678}>Sao Tome and Principe</option>
                    <option className="dead_air" value={682}>Saudi Arabia</option>
                    <option value={686}>Senegal</option>
                    <option className="dead_air" value={688}>Serbia</option>
                    <option className="dead_air" value={690}>Seychelles</option>
                    <option value={694}>Sierra Leone</option>
                    <option className="dead_air" value={702}>Singapore</option>
                    <option className="dead_air" value={703}>Slovakia</option>
                    <option className="dead_air" value={705}>Slovenia</option>
                    <option value={90}>Solomon Islands</option>
                    <option value={706}>Somalia</option>
                    <option value={710}>South Africa</option>
                    <option className="dead_air" value={728}>South Sudan</option>
                    <option className="dead_air" value={724}>Spain</option>
                    <option value={144}>Sri Lanka</option>
                    <option value={275}>State of Palestine</option>
                    <option className="dead_air" value={729}>Sudan</option>
                    <option className="dead_air" value={740}>Suriname</option>
                    <option className="dead_air" value={748}>Swaziland</option>
                    <option className="dead_air" value={752}>Sweden</option>
                    <option className="dead_air" value={756}>Switzerland</option>
                    <option className="dead_air" value={760}>Syrian Arab Republic</option>
                    <option value={762}>Tajikistan</option>
                    <option className="dead_air" value={807}>TFYR Macedonia</option>
                    <option className="dead_air" value={764}>Thailand</option>
                    <option value={626}>Timor-Leste</option>
                    <option value={768}>Togo</option>
                    <option className="dead_air" value={776}>Tonga</option>
                    <option className="dead_air" value={780}>Trinidad and Tobago</option>
                    <option className="dead_air" value={788}>Tunisia</option>
                    <option className="dead_air" value={792}>Turkey</option>
                    <option className="dead_air" value={795}>Turkmenistan</option>
                    <option value={800}>Uganda</option>
                    <option className="dead_air" value={804}>Ukraine</option>
                    <option className="dead_air" value={784}>United Arab Emirates</option>
                    <option className="dead_air" value={826}>United Kingdom</option>
                    <option value={834}>United Republic of Tanzania</option>
                    <option className="dead_air" value={840}>United States of America</option>
                    <option className="dead_air" value={850}>United States Virgin Islands</option>
                    <option className="dead_air" value={858}>Uruguay</option>
                    <option value={860}>Uzbekistan</option>
                    <option className="dead_air" value={548}>Vanuatu</option>
                    <option className="dead_air" value={862}>Venezuela (Bolivarian Republic of)</option>
                    <option value={704}>Viet Nam</option>
                    <option className="dead_air" value={732}>Western Sahara</option>
                    <option value={887}>Yemen</option>
                    <option value={894}>Zambia</option>
                    <option value={716}>Zimbabwe</option>
                </select>

            </div>
        )
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/dropdown.js